CCL.categoryCarousel = {
  autoload: [
    ['categoryStick', $('.sticky-container').length > 0]
  ],

  categoryStick() {
    const stickyOffset = $('.sticky-container').offset().top;
    $(window).scroll(() => {
      const sticky = $('.sticky-container');
      const scroll = $(window).scrollTop();
      if (scroll >= stickyOffset) {
        sticky.addClass('sticky-fixed');
        $('.sticky-fixed').next().addClass('addPadding-after-scroll');
      } else {
        $('.sticky-fixed').next().removeClass('addPadding-after-scroll');
        sticky.removeClass('sticky-fixed');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-category-carousel/category-carousel.js